module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_moscatello_sm-b38f6e8be09295a886b4a44cf7a52669.png";